export function leftPad(value: number, length: number, paddingChar: string) {
  const paddingLength = Math.max(0, length - String(value).length);
  return paddingChar.repeat(paddingLength) + value;
}
